import React, { useEffect, useState } from 'react'
import { postFormasDeLiquidacionFORLIQ } from '../../../services/Contratacion'
import Loading from '../../Loading'
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { UserTokenURL } from '../../../services/ApiHIS';
import ModalCrearFormasDeLiquidacion from './ModalCrearFormasDeLiquidacion';
import ModalConfirmarExcelFormasDeLiquidacion from './ModalConfirmarExcelFormasDeLiquidacion';
import ConsultarFormasDeLiquidacion from './ConsultarFormasDeLiquidacion';
import ModalUpdateFormasDeLiquidar from './ModalUpdateFormasDeLiquidar';
import ModalEliminarUnaFormaDeliquidacion from './ModalEliminarUnaFormaDeliquidacion';

const FormasDeLiquidacion = () => {
  const [dataFormasLiquidacion, setdataFormasLiquidacion]=useState([])
  const [selectCheckboxFormasLiquidacion, setselectCheckboxFormasLiquidacion]=useState('')
  const [loading,setloading]=useState(false)
  const [create, setcreate]=useState(false)
  const [modalOnExcelFormasLiquidacion, setmodalOnExcelFormasLiquidacion]=useState(false)
  const [actualizarDataFormasLiquidar, setactualizarDataFormasLiquidar]=useState([])
  const [dataConsultarEliminarModificar, setdataConsultarEliminarModificar]=useState(null)
  const [consultar, setconsultar]=useState(false)
  const [update, setupdate]=useState(false)    
  const [modalOndelete, setmodalOndelete]=useState(false)
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

    useEffect(()=>{
      setselectCheckboxFormasLiquidacion('')
      setdataConsultarEliminarModificar(null)
        const body={
            "forLiqCod":"",
            "forLiqDsc":""
        }
        postFormasDeLiquidacionFORLIQ(body).then((res)=>{
          setloading(true)
          setdataFormasLiquidacion(res.data.data)
        })
    },[actualizarDataFormasLiquidar])

     //token
  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL()  

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response.data.user_data, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      console.log(usuarioInfo, 'usuarioInfoStr confirmado')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])

  const handleOnclickUpdate=()=>{
    if(selectCheckboxFormasLiquidacion && dataConsultarEliminarModificar){
      setupdate(true)
    }
    
  }
 
  const handleOnclickDelete=()=>{
    if(selectCheckboxFormasLiquidacion && dataConsultarEliminarModificar){
      setmodalOndelete(true)
    }
  }

  const searchFormasLiquidacion=(e)=>{
    e.preventDefault();
    const body={
      "forLiqCod":e.target.codigo.value,
      "forLiqDsc":e.target.descripcion.value
  }
  setloading(false)
  postFormasDeLiquidacionFORLIQ(body).then((res)=>{
    setloading(true)
    setdataFormasLiquidacion(res.data.data)
  })
  }

  const passDataActualizarDataFormasLiquidar=(data)=>{
    setactualizarDataFormasLiquidar(data)
  }

  const handleOnclickCreate=()=>{
    setcreate(true)
  }

  const handleOnclickConsultar=()=>{
    if(selectCheckboxFormasLiquidacion && dataConsultarEliminarModificar){
      setconsultar(true)
    }
}

  const handleOnclicExcelFormasLiquidacion=()=>{
    setmodalOnExcelFormasLiquidacion(true)
  }

  const handleCheckboxChange=(id,data)=>{
    //console.log(data,'data')
    setselectCheckboxFormasLiquidacion(id)
    setdataConsultarEliminarModificar(data)
  }
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Formas de Liquidación
        </div>

        <form onSubmit={searchFormasLiquidacion}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Codigo
              </label>
              <div className="flex">
                <input
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="mb-3 xl:w-96 px-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Descripción
              </label>
              <div className="flex">
                <input
                  name="descripcion"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form >
        <div className="flex ">
          
        <button
        onClick={handleOnclickCreate}
        type="button"
        className="inline-block px-6 py-1.5 bg-violet-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-violet-700 hover:shadow-lg focus:bg-violet-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-violet-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Crear
      </button>
      
      <div className='px-2'>
      <button
                  onClick={handleOnclickUpdate}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Modificar 
                </button>
      </div>
      <div className='px-2'>
      <button
                  onClick={handleOnclickConsultar}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-yellow-700 hover:shadow-lg focus:bg-yellow-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Consultar
                </button>      
      </div>
      <div className='px-2'>
      <button
                  onClick={handleOnclickDelete}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Eliminar
                </button>
      </div>
      <div className='px-2'>
      <button
        onClick={handleOnclicExcelFormasLiquidacion}
        type="button"
        className="inline-block px-6 py-1.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Excel
      </button>      
      </div>
      </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >                        
                      </th>                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Codigo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción
                      </th>                      
                    </tr>
                  </thead>
                  <tbody >
                  {loading ? (
                    dataFormasLiquidacion.map((item,index)=>(                      
                      <tr className=" divide-y divide-slate-700 " key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                        <div className="topping">
                        <input
                                  type="checkbox"
                                  checked={selectCheckboxFormasLiquidacion === item.ForLiqCod}
                                  onChange={() => handleCheckboxChange(item.ForLiqCod,item)}
                                />                          
                        </div>
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                          {item.ForLiqCod}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
                        {item.ForLiqDsc}
                        </td>
                      </tr> 
                    ))                   
                  ) : (                    
                      <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>
                        <td>
                          <Loading /> 
                        </td>
                        <td></td>
                      </tr>
                  )}
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {create? <ModalCrearFormasDeLiquidacion setcreate={setcreate} dataFormasLiquidacion={dataFormasLiquidacion} passDataActualizarDataFormasLiquidar={passDataActualizarDataFormasLiquidar}/>:null}
      {modalOnExcelFormasLiquidacion? <ModalConfirmarExcelFormasDeLiquidacion setmodalOnExcelFormasLiquidacion={setmodalOnExcelFormasLiquidacion}/>:null}
      {consultar? <ConsultarFormasDeLiquidacion setconsultar={setconsultar} item={dataConsultarEliminarModificar}/>:null}
      {update? <ModalUpdateFormasDeLiquidar setupdate={setupdate} item={dataConsultarEliminarModificar} passDataActualizarDataFormasLiquidar={passDataActualizarDataFormasLiquidar}/>:null}
      {modalOndelete? <ModalEliminarUnaFormaDeliquidacion setmodalOndelete={setmodalOndelete} item={dataConsultarEliminarModificar} passDataActualizarDataFormasLiquidar={passDataActualizarDataFormasLiquidar}/>:null}
    </>
  )
}

export default FormasDeLiquidacion